export default { sha: 'd5fbccd24b1b8196746ff3e45fee014c14a24222', buildNumber: 'undefined' }
